var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAddMoney = function SvgAddMoney(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 31,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "add-money_svg__a",
    width: 32,
    height: 31,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M.5 0h31v31H.5z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#add-money_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    x: 0.5,
    y: 0.004,
    fill: "#FF2E5B",
    rx: 15.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.133 17.035h4.137v-2.424h-4.137V13.23c0-1.615 1.002-2.614 2.516-2.614 1.28 0 2.176.68 2.432 1.87h2.837c-.32-2.657-2.346-4.337-5.269-4.337-3.178 0-5.31 1.999-5.31 5.082v1.381H10.08v2.424h1.258v3.402H10.08v2.423h11.56v-2.423h-7.507z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5B3552",
    d: "M32.577 8.156h-4.833v4.617h-3.375V8.156h-4.833V4.889h4.833V.272h3.375v4.617h4.833z"
  }))));
};
export { SvgAddMoney as ReactComponent };
export default __webpack_public_path__ + "images/add-money.svg";